import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class SettingService {

    private countryData: any[] = [];
  constructor() { }

  setCountryData(data: any[]) {
    this.countryData = data;
  }

   getMinMaxLength(countryCode: string) {
    const country = this.countryData.find(c => c.countryCode === countryCode);
    return country ? { minLength: country.minMobileNumberLength, maxLength: country.maxMobileNumberLength } : { minLength: 5, maxLength: 20 }; 
  }
  getPinCodeMinMaxLength(countryCode: string) {
    const country = this.countryData.find(c => c.countryCode === countryCode);
    return country ? { minPinLength: country.minPincodeLength, maxPinLength: country.maxPincodeLength } : { minLength: 6, maxLength: 6 }; 
  }
}